// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1Fe_p","list":"styles_list__2IIKt"};